import styled from 'styled-components';

import { theme } from 'assets/styles/theme';
import { H6 } from 'components/typography/Headers';
import { CampaignDto } from 'services/Campaign/campaignService.dto';
import { convertToThumbnail600 } from 'utils/thumbnails';

import { CampaignInactiveOverlay } from './CampaignInactiveOverlay';
import CampaignPhoto from './CampaignPhoto';
import { CampaignProgressBar } from './CampaignProgressBar';
import CampaignStats from './CampaignStats';

export const TileContainer = styled.div`
  position: relative;
  border: 1px solid ${theme.color.lightGray};
  border-radius: 5px;
  padding: 10px;
  background: ${theme.color.white};
  cursor: pointer;
  min-width: 0;
  height: 100%;
`;

const DataContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  justify-content: space-between;
  gap: 12px;
`;

const CampaignName = styled(H6)`
  overflow: hidden;
  word-break: break-word;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  padding: 0;
`;

interface Props {
  campaign: CampaignDto;
  onClick: (campaign: CampaignDto) => void;
}

const CampaignTile = ({ campaign, onClick }: Props) => {
  const campaignImage = campaign.imageUrls.length > 0 ? convertToThumbnail600(campaign.imageUrls[0]) : undefined;

  return (
    <TileContainer data-testid={'campaign-tile_' + campaign.id} onClick={() => onClick(campaign)}>
      <CampaignPhoto image={campaignImage} isHidden={campaign.isHidden!!} campaignStatus={campaign.status} />
      <DataContainer>
        <CampaignName data-testid={'campaign-name'}>{campaign.name}</CampaignName>
        <CampaignProgressBar value={campaign.fundsRaised} total={campaign.moneyGoal} />
        <CampaignStats
          timelineFrom={campaign.timelineFrom!!}
          timelineTo={campaign.timelineTo}
          supportersNumber={campaign.supportersNumber}
          status={campaign.status}
        />
      </DataContainer>
      <CampaignInactiveOverlay isHidden={campaign.isHidden!!} campaignStatus={campaign.status} />
    </TileContainer>
  );
};

export default CampaignTile;
